import { render, staticRenderFns } from "./versionDetail.vue?vue&type=template&id=3389c5c9&scoped=true"
import script from "./versionDetail.vue?vue&type=script&lang=js"
export * from "./versionDetail.vue?vue&type=script&lang=js"
import style0 from "./versionDetail.vue?vue&type=style&index=0&id=3389c5c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389c5c9",
  null
  
)

export default component.exports